import React, { useState } from 'react';
import ScratchCard from 'react-scratchcard';
import { AiFillGithub, AiFillInstagram, AiFillLinkedin } from 'react-icons/ai';

const Socials = () => {
  const [socialTitle, setSocialTitle] = useState('Scratch Cards Below');
  const settings1 = {
    width: 250,
    height: 250,
    image: 'images/scratchCard.png',
    finishPercent: 70,
    onComplete: () => setSocialTitle('Yay! You won my Socials!'),
  };

  return (
    <div className="socials">
      <div className="socials_container">
        <h1 className="socials_title">{socialTitle}</h1>

        <div className="socials_scratchCard">
          <ScratchCard {...settings1}>
            <a
              href="https://www.instagram.com/aryan_bhandari__/"
              target="_blank"
              rel="noreferrer"
            >
              <AiFillInstagram style={{ color: '#CB3993', fontSize: '50px' }} />
              <span>Instagram</span>
            </a>
          </ScratchCard>
          <ScratchCard {...settings1}>
            <a
              href="https://github.com/AryanBhandari47/"
              target="_blank"
              rel="noreferrer"
            >
              <AiFillGithub style={{ color: '#ffffff', fontSize: '50px' }} />
              <span>GitHub</span>
            </a>
          </ScratchCard>
          <ScratchCard {...settings1}>
            <a
              href="https://www.linkedin.com/in/aryan-bhandari47"
              target="_blank"
              rel="noreferrer"
            >
              <AiFillLinkedin style={{ color: '#0077B5', fontSize: '50px' }} />
              <span>LinkedIn</span>
            </a>
          </ScratchCard>
        </div>
      </div>
    </div>
  );
};

export default Socials;
